import React from 'react';
import Badge from '../Badge';
import { iconSportCssClass } from '../../data/utils';
import CategoryCollapse from './CategoryCollapse';
import { useFilter } from '../../prematch/by-date/FilterProvider';
import { getLabel } from '../../InitData';

export default function MenuSportCollapse(props) {
    const filter = useFilter();

    const sport = props.data;
    const icon = iconSportCssClass(sport.id, sport.iconClass);
    const eventsCount = sport.eventsCountByFilter?.[filter] ?? sport.eventsCount

    let categories = sport.categories;
    if (filter != null) {
        categories = categories.filter(c => c.filters?.[filter] ?? true != null);
    }

    return (
        <div className="c_16" onClick={props.close}>
            <div className="c_16_1">
                <div className={"c_16_1_1 " + icon}></div>
                <div className="c_16_1_2">{sport.descrizione}</div>
                <div className="c_16_1_3">
                    {sport.isLive &&
                        <Badge desc={getLabel('general.live')} />
                    }
                    <div className="c_16_1_3_1">{eventsCount}</div>
                </div>
            </div>
            {categories.map(c =>
                <CategoryCollapse key={c.id} data={c} />
            )}
        </div>
    );
}
